module.exports = __webpack_public_path__ + "static/media/pops-raspberry-tangerine-nutrition.0e6f7b82.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/ourProducts/products/nutrition-facts/pops-raspberry-tangerine-nutrition.png
// module id = 195
// module chunks = 0